import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IProductPriceStyles } from "./ProductPrice.types"

export const ProductPriceStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IProductPriceStyles>
> = () => ({
    root: {}
})
